import { GOOGLE, LINKEDIN, META, TIKTOK } from "../../../../utils/constants";

export const UTM_FIXED_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_id",
  "utm_campaign",
  "utm_content",
];

/** Google: no fixed UI for these; incoming values are edited as custom params. */
const UTM_GOOGLE_KEYS_AS_CUSTOM_ONLY = ["utm_medium", "utm_id"];

/**
 * UTM keys shown as fixed rows in the modal (platform-specific).
 */
export const getFixedUtmKeysForPlatform = (platform) => {
  if (platform === GOOGLE) {
    return UTM_FIXED_KEYS.filter(
      (key) => !UTM_GOOGLE_KEYS_AS_CUSTOM_ONLY.includes(key)
    );
  }
  return UTM_FIXED_KEYS;
};

/**
 * Keys that cannot be used as custom param names (lowercase match).
 * For Google, utm_medium / utm_id are allowed as custom.
 */
export const getUtmKeysReservedForCustomParams = (platform) => {
  if (platform === GOOGLE) {
    return UTM_FIXED_KEYS.filter(
      (key) => !UTM_GOOGLE_KEYS_AS_CUSTOM_ONLY.includes(key)
    );
  }
  return UTM_FIXED_KEYS;
};

export const PLATFORM_REPLACE_VARIABLES = {
  [META]: [
    "{{campaign.id}}",
    "{{campaign.name}}",
    "{{adset.id}}",
    "{{adset.name}}",
    "{{ad.id}}",
    "{{ad.name}}",
    "{{placement}}",
    "{{site_source_name}}",
  ],
  [TIKTOK]: [
    "__CAMPAIGN_ID__",
    "__CAMPAIGN_NAME__",
    "__AID__",
    "__AID_NAME__",
    "__CID__",
    "__CID_NAME__",
    "__PLACEMENT__",
  ],
  [LINKEDIN]: [
    "{{CAMPAIGN_ID}}",
    "{{CAMPAIGN_NAME}}",
    "{{AD_SET_ID}}",
    "{{AD_SET_NAME}}",
    "{{AD_ID}}",
    "{{AD_NAME}}",
    "{{ACCOUNT_ID}}",
    "{{ACCOUNT_NAME}}",
  ],
  [GOOGLE]: [],
};

const DEFAULT_UTM_PARAMS_BY_PLATFORM = {
  [META]: {
    utm_source: "meta_ads",
    utm_medium: "{{adset.name}}",
    utm_id: "{{campaign.id}}",
    utm_campaign: "{{campaign.name}}",
    utm_content: "{{ad.name}}",
  },
  [TIKTOK]: {
    utm_source: "tiktok_ads",
    utm_medium: "__AID_NAME__",
    utm_id: "__CAMPAIGN_ID__",
    utm_campaign: "__CAMPAIGN_NAME__",
    utm_content: "__CID_NAME__",
  },
  [LINKEDIN]: {
    utm_source: "linkedin_ads",
    utm_medium: "{{AD_SET_NAME}}",
    utm_id: "{{CAMPAIGN_ID}}",
    utm_campaign: "{{CAMPAIGN_NAME}}",
    utm_content: "{{AD_NAME}}",
  },
  [GOOGLE]: {
    utm_source: "google_ads",
    utm_medium: "",
    utm_id: "",
    utm_campaign: "",
    utm_content: "",
  },
};

export const getDefaultUtmParamsByPlatform = (platform) => {
  return (
    DEFAULT_UTM_PARAMS_BY_PLATFORM[platform] ||
    DEFAULT_UTM_PARAMS_BY_PLATFORM[META]
  );
};
